/**
 * Permission constants for role-based access control
 */

export const PERMISSIONS = Object.freeze({
  VIEW_STUDENTS: 1,
  MANAGE_STUDENTS: 2,
  VIEW_EXAMS: 4,
  VIEW_ANALYTICS: 64,
  MANAGE_MEMBERS: 128,
  VIEW_REGISTRATIONS: 256,
});

export const ROLES = Object.freeze({
  ADMIN: 'ADMIN',
});

export const ROLE_LABELS = Object.freeze({
  PLATFORM_ADMIN: 'Platform Admin',
  PARTNER_ADMIN: 'Partner Admin',
});

// Routes accessible by Partner Admins (with scoped data)
export const PARTNER_ACCESSIBLE_ROUTES = [
  '/admin-dashboard',
  '/exams',
  '/registrations-management',
  '/scores-management',
  '/reading-answers',
  '/listening-answers',
  '/writing-answers',
  '/partner-students',
  '/partner-members',
];

// Routes only for Platform Admin
export const PLATFORM_ONLY_ROUTES = [
  '/users-management',
  '/referrals-management',
  '/product-sessions',
  '/sessions-management',
  '/invoices-management',
  '/speaking-sessions',
  '/feedbacks',
  '/readings',
  '/listenings',
  '/writings',
  '/speakings',
  '/blogs',
  '/instructors',
  '/speaking-feedback',
];
